'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* globals ModuleRegistry */

var configBusinessSettings = exports.configBusinessSettings = function configBusinessSettings(_ref) {
  var moduleId = _ref.moduleId,
      appDefIds = _ref.appDefIds;

  var settings = ModuleRegistry.getModule('SETTINGS');
  settings.config(moduleId, { appDefIds: appDefIds });
};

var getBusinessSettings = exports.getBusinessSettings = function getBusinessSettings(metaSideId) {
  return ModuleRegistry.invoke('businessSettings.getBusinessSettings', metaSideId);
};

var onUpdateBusinessSettings = exports.onUpdateBusinessSettings = function onUpdateBusinessSettings(callback) {
  return ModuleRegistry.addListener('businessSettings.onUpdateBusinessSettings', function (_ref2) {
    var metaSiteId = _ref2.metaSiteId,
        settings = _ref2.settings;

    callback({ metaSiteId: metaSiteId, settings: settings });
  });
};

var onLoad = exports.onLoad = function onLoad(callback) {
  return ModuleRegistry.addListener('businessSettings.onLoad', function (_ref3) {
    var settings = _ref3.settings;

    callback({ settings: settings });
  });
};

var onLanguageAndRegionPageLoad = exports.onLanguageAndRegionPageLoad = function onLanguageAndRegionPageLoad(callback) {
  return ModuleRegistry.addListener('businessSettings.onLanguageAndRegionPageLoad', function (_ref4) {
    var settings = _ref4.settings;

    callback({ settings: settings });
  });
};

var onBusinessInfoPageLoad = exports.onBusinessInfoPageLoad = function onBusinessInfoPageLoad(callback) {
  return ModuleRegistry.addListener('businessSettings.onBusinessInfoPageLoad', function () {
    callback();
  });
};

var onFieldChange = exports.onFieldChange = function onFieldChange(callback) {
  return ModuleRegistry.addListener('businessSettings.onFieldChange', function (_ref5) {
    var changedField = _ref5.changedField;

    callback({ changedField: changedField });
  });
};

var reportUnsupportedLanguage = exports.reportUnsupportedLanguage = function reportUnsupportedLanguage(_ref6) {
  var appName = _ref6.appName,
      language = _ref6.language;

  return ModuleRegistry.invoke('businessSettings.reportUnsupportedLanguage', { appName: appName, language: language });
};

var reportIneffectiveCurrencyChange = exports.reportIneffectiveCurrencyChange = function reportIneffectiveCurrencyChange(_ref7) {
  var appName = _ref7.appName,
      currency = _ref7.currency;

  return ModuleRegistry.invoke('businessSettings.reportIneffectiveCurrencyChange', { appName: appName, currency: currency });
};

var reportUnsupportedShippingRuleCurrency = exports.reportUnsupportedShippingRuleCurrency = function reportUnsupportedShippingRuleCurrency(_ref8) {
  var appName = _ref8.appName,
      currency = _ref8.currency,
      serviceProvider = _ref8.serviceProvider;

  return ModuleRegistry.invoke('businessSettings.reportUnsupportedShippingRuleCurrency', { appName: appName, currency: currency, serviceProvider: serviceProvider });
};